import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://narrowitsolution.in/api";

// === Fetch All Service Types (GET with filters) ===
export const fetchAllServiceTypes = createAsyncThunk(
  "serviceType/fetchAllServiceTypes",
  async (filters = {}, { rejectWithValue }) => {
    try {
      // ✅ Get superadminId (from filters or localStorage)
      const superadminId =
        filters.superadminId || localStorage.getItem("adminuserId");

      // ✅ Build query params
      const queryParams = new URLSearchParams({
        ...(superadminId && { superadminId }),
      }).toString();

      // ✅ API call
      const response = await axios.get(
        `${BASE_URL}/all-servicetype`
      );

      return response.data; // { success, data: [...] }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

const serviceTypeSlice = createSlice({
  name: "serviceType",
  initialState: {
    allServiceTypes: [],
    loadingservice: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllServiceTypes.pending, (state) => {
        state.loadingservice = true;
        state.error = null;
      })
      .addCase(fetchAllServiceTypes.fulfilled, (state, action) => {
        state.loadingservice = false;
        state.allServiceTypes = action.payload?.data || [];
      })
      .addCase(fetchAllServiceTypes.rejected, (state, action) => {
        state.loadingservice = false;
        state.error = action.payload;
      });
  },
});

export default serviceTypeSlice.reducer;
